module.exports = __webpack_public_path__ + "Roboto-Bold.39b2c3031be6b4ea96e2.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Bold.woff2
// module id = 459
// module chunks = 2